/* eslint-disable import/prefer-default-export */
import { styled } from '@mui/material/styles';

export const ChangesAndShareContainer = styled('div')`
	display: flex;
	align-items: center;
`;
